:host {
  --cms-button-border-color: initial;
  --cms-button-border: var(--cms-border-size-sm) solid var(--cms-button-border-color);
  --cms-button-background-color: initial;
  --cms-button-color: initial;
  --cms-button-hover-color: initial;
  --cms-button-active-color: initial;
  --cms-button-focus-color: initial;
  --cms-button-padding: initial;
  --cms-button-margin-bottom: initial;
  --cms-button-font-size: var(--cms-font-size-100);
  --cms-button-line-height: initial;
  --cms-button-icon-spacing: initial;
  --cms-button-height: initial;
  --cms-button-width: initial;
  --cms-button-text-transform: uppercase;
  box-sizing: border-box;
  display: inline-block;
  width: auto;
}

:host(.disabled) {
  opacity: 0.4;
  pointer-events: none;
}

:host(.primary) {
  --cms-button-border-color: var(--cms-semanticColors-primary-border);
  --cms-button-background-color: var(--cms-semanticColors-primary-background);
  --cms-button-color: var(--cms-semanticColors-primary-textOnBackground);
  --cms-button-hover-color: var(--cms-semanticColors-primary-hover-background);
  --cms-button-active-color: var(--cms-semanticColors-primary-active-background);
  --cms-button-focus-color: var(--cms-semanticColors-primary-focus-outline);
}

:host(.primary-buy) {
  --cms-button-border-color: var(--cms-semanticColors-buy-strong-border);
  --cms-button-background-color: var(--cms-semanticColors-buy-strong-background);
  --cms-button-color: var(--cms-semanticColors-buy-strong-textOnBackground);
  --cms-button-hover-color: var(--cms-semanticColors-buy-hover-background);
  --cms-button-active-color: var(--cms-semanticColors-buy-strong-active-background);
  --cms-button-focus-color: var(--cms-semanticColors-buy-focus-outline);
}

:host(.secondary) {
  --cms-button-border-color: var(--cms-theme-border-color);
  --cms-button-background-color: var(--cms-semanticColors-transparency-strong-background);
  --cms-button-color: var(--cms-theme-text-color);
  --cms-button-hover-color: var(--cms-theme-strong-hover);
  --cms-button-active-color: var(--cms-theme-strong-active-background);
  --cms-button-focus-color: var(--cms-theme-focus-outline);
}

:host(.static-light.secondary) {
  --cms-button-color: var(--cms-semanticColors-base-strong-text);
  --cms-button-border-color: var(--cms-semanticColors-base-strong-border);
  --cms-button-hover-color: var(--cms-semanticColors-transparency-strong-hover-background);
  --cms-button-active-color: var(--cms-semanticColors-transparency-strong-active-background);
  --cms-button-focus-color: var(--cms-semanticColors-transparency-focus-outline);
}

:host(.secondary-inverted) {
  --cms-button-border-color: var(--cms-semanticColors-base-inverted-strong-border);
  --cms-button-background-color: var(--cms-semanticColors-transparency-inverted-strong-background);
  --cms-button-color: var(--cms-semanticColors-base-inverted-strong-text);
  --cms-button-hover-color: var(--cms-semanticColors-transparency-inverted-strong-hover-background);
  --cms-button-active-color: var(--cms-semanticColors-transparency-inverted-strong-active-background);
  --cms-button-focus-color: var(--cms-semanticColors-base-inverted-focus-outline);
}

:host(.flat) {
  --cms-button-text-transform: normal;
  --cms-button-border-color: var(--cms-semanticColors-transparency-strong-background);
  --cms-button-background-color: var(--cms-semanticColors-transparency-strong-background);
  --cms-button-color: var(--cms-theme-text-color);
  --cms-button-hover-color: var(--cms-semanticColors-transparency-strong-hover-background);
  --cms-button-active-color: var(--cms-semanticColors-transparency-strong-active-background);
  --cms-button-focus-color: var(--cms-semanticColors-base-focus-outline);
}

:host(.flat-inverted) {
  --cms-button-border-color: var(--cms-semanticColors-transparency-strong-background);
  --cms-button-background-color: var(--cms-semanticColors-transparency-strong-background);
  --cms-button-color: var(--cms-semanticColors-transparency-inverted-strong-textOnBackground);
  --cms-button-hover-color: var(--cms-semanticColors-transparency-inverted-strong-hover-background);
  --cms-button-active-color: var(--cms-semanticColors-transparency-inverted-strong-active-background);
  --cms-button-focus-color: var(--cms-semanticColors-base-inverted-focus-outline);
}

:host(.button-xs) {
  --cms-button-padding: var(--cms-spacing-025) var(--cms-spacing-075);
  --cms-button-font-size: var(--cms-font-size-100);
  --cms-button-line-height: var(--cms-line-height-114);
  --cms-button-icon-spacing: var(--cms-spacing-025);
  --cms-button-height: 1.75rem;
}

:host(.button-xs.only-icon) {
  --cms-button-padding: var(--cms-spacing-025);
  --cms-button-width: 1.75rem;
}

:host(.button-sm) {
  --cms-button-padding: var(--cms-spacing-025) var(--cms-spacing-075);
  --cms-button-margin-bottom: var(--cms-spacing-025);
  --cms-button-font-size: var(--cms-font-size-100);
  --cms-button-line-height: var(--cms-line-height-114);
  --cms-button-icon-spacing: var(--cms-spacing-025);
  --cms-button-height: 2.25rem;
}

:host(.button-sm.only-icon) {
  --cms-button-padding: var(--cms-spacing-025);
  --cms-button-width: 2.25rem;
}

:host(.button-md) {
  --cms-button-padding: var(--cms-spacing-050) var(--cms-spacing-100);
  --cms-button-margin-bottom: var(--cms-spacing-050);
  --cms-button-font-size: var(--cms-font-size-112);
  --cms-button-line-height: var(--cms-line-height-133);
  --cms-button-icon-spacing: var(--cms-spacing-050);
}

:host(.button-md.only-icon) {
  --cms-button-padding: var(--cms-spacing-050);
}

:host(.button-lg) {
  --cms-button-padding: var(--cms-spacing-075) var(--cms-spacing-100);
  --cms-button-margin-bottom: var(--cms-spacing-050);
  --cms-button-font-size: var(--cms-font-size-112);
  --cms-button-line-height: var(--cms-line-height-133);
  --cms-button-icon-spacing: var(--cms-spacing-050);
}

:host(.button-lg.only-icon) {
  --cms-button-padding: var(--cms-spacing-075);
}

:host(.only-icon) {
  --cms-button-icon-spacing: 0;
}

.native-button {
  height: var(--cms-button-height);
  background-color: var(--cms-button-background-color);
  color: var(--cms-button-color);
  border: var(--cms-button-border);
  border-radius: var(--cms-border-radius-sm);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: var(--cms-button-padding);
  font-family: var(--cms-brandfont2);
  font-size: var(--cms-button-font-size);
  text-decoration: none;
  line-height: var(--cms-button-line-height);
  font-weight: var(--cms-heading-base-font-weight);
  outline: none;
  text-transform: var(--cms-button-text-transform);
  width: 100%;
  width: -moz-available;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available;
  opacity: 1;
  min-width: var(--cms-button-width);
  max-width: var(--cms-button-width);
}

.native-button cms-icon {
  margin-left: var(--cms-button-icon-spacing);
}

// Button Hover
@media (any-hover: hover) {
  :host(:hover) {
    --cms-button-background-color: var(--cms-button-hover-color);
  }
}

.native-button:active {
  background: var(--cms-button-active-color);
}

.native-button:focus-visible {
  box-shadow: 0 0 0 var(--cms-spacing-025) var(--cms-button-focus-color);
}